import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doGet } from "../../config/fetchWrapper";
import { urls } from "../endPoints";

export const S3URLRequestAction = createAsyncThunk("s3UrlRequest",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doGet(`${urls?.s3Url}?screenShot=${payload}`);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const S3URLRequestSlice = createSlice({
    name: "s3UrlRequest",
    initialState: {
        isLoading: false,
        data: false,
        error: null,
        success: false
    },
    reducers: {
        S3URLRequestReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false
            };
        },
    },
    extraReducers: {
        [S3URLRequestAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [S3URLRequestAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [S3URLRequestAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { S3URLRequestReset } = S3URLRequestSlice.actions
export default S3URLRequestSlice.reducer